import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloudUploadIcon from '../../../../../../components/Icons/CloudUploadIcon';
import {
  CONTRATO_ENTE_PUBLICO_EXTRATO_FILE_TYPES,
  CONTRATO_ENTE_PUBLICO_EXTRATO_MAX_FILE_SIZE,
  uploadFileValidation,
} from '../../../../../../utils/ValidationUtils';
import arquivosStyles from '../Arquivos.scss';
import { uploadExtratoContratoEntePublico } from '../../../../../../store/modules/ContratosEntePublicoActions';
import CustomUploadEntePublico from '../../../../../../components/CustomUploadButton/CustomUploadEntePublico/CustomUploadEntePublico';

class UploadExtratoButton extends Component {
  getArquivoId = () => {
    return this.props.arquivo.idDocExtrato;
  };

  isShown = () => {
    return (
      (!this.getArquivoId() &&
        this.props.auth.userPermissions.contratos.entePublico.uploadAssinado) ||
      this.props.auth.userPermissions.contratos.entePublico.changeUploadExtrato
    );
  };

  isLoading = () => {
    return this.props.contratosEntePublico.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      !this.props.arquivo.idDocAssinado ||
      this.props.contratosEntePublico.loadingAlteraArquivo ||
      (!this.props.auth.userPermissions.contratos.editEvenWhenDisabled &&
        (!!this.props.arquivo.idDocExtrato ||
          !arquivo.isLatest ||
          !arquivo.idDocNaoAssinado ||
          !arquivo.ativo))
    );
  };

  fileIsValid = (file) => {
    const validation = uploadFileValidation(
      file,
      CONTRATO_ENTE_PUBLICO_EXTRATO_FILE_TYPES,
      CONTRATO_ENTE_PUBLICO_EXTRATO_MAX_FILE_SIZE,
      this.props.languageValues.errorFileTypeContrato,
      this.props.languageValues.errorFileSizeContrato
    );
    return validation;
  };

  uploadAction = (data, callbackProgress, callbackSuccess, callbackError) => {
    this.props.uploadExtratoContratoEntePublico(
      data.file,
      this.props.arquivo.id,
      this.props.arquivo.versaoContrato,
      callbackSuccess,
      callbackError,
      (obj) => callbackProgress(obj.percent)
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    const isAditivo = !!this.props.contratosEntePublico.contratoEditing;

    return arquivo && this.isShown() ? (
      <CustomUploadEntePublico
        id={arquivo.id}
        isAditivo={isAditivo}
        hideLabel
        className={arquivosStyles.rootClassName + '-action-button'}
        buttonComponent={CustomIconButton}
        buttonComponentProps={{
          id: 'upload-extrato-' + arquivo.id,
          name: 'data-cy',
          size: 'small',
          icon: <CloudUploadIcon />,
          theme: 'pufvYellow',
          tooltip:
            this.props.languageValues.cadastroContratoArquivosUploadExtrato,
          tooltipProps: {
            className:
              arquivosStyles.rootClassName + '-action-button-tooltip-caller',
          },
        }}
        fileIsValid={this.fileIsValid}
        uploadAction={this.uploadAction}
        uploadActionData={{}}
        feedbackOnModal
        feedbackOnModalTitle={
          this.props.languageValues.cadastroContratoArquivosUploadingExtrato
        }
        disabled={this.isDisabled()}
        uploadActionSuccessCallback={this.props.refreshStep}
      />
    ) : null;
  }
}

UploadExtratoButton.propTypes = {
  id: PropTypes.string.isRequired,
  arquivo: PropTypes.object.isRequired,
  refreshStep: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadExtratoContratoEntePublico,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadExtratoButton);
